import {
  Component,
  Input
} from "@angular/core";
import { Utility } from "../../../shared/utility/utility";
import { EmitterService } from "../../../services/emitter.service";

@Component({
  selector: "app-dynamic-field",
  templateUrl: "./dynamic-field.component.html",
  styleUrls: ["./dynamic-field.component.scss"],
})
export class DynamicFieldComponent {
  @Input() field:any;
  @Input() form:any;
  validationClass='';
  isSubmitted = false;
  message = '';
  
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }

  constructor(private utils:Utility,private emitterService:EmitterService) { 
    this.emitterService.emitSubmitFormClick$.subscribe((status)=>{
      this.isSubmitted = true;
    });
  }

  shouldShowErrors(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName);
  }
  getErrorMessage() {
    let fieldName = this.field.name;
    let formName = this.form;
    if(this.shouldShowErrors(fieldName, formName) && document.activeElement.id != fieldName){
      this.validationClass = this.form.controls[this.field.name].value ?  'field-invalid' : 'field-valid'; 
     return this.utils.getErrorMessage(fieldName, formName);
    }
    this.validationClass = '';
    return '';
  }
}
